import { render, staticRenderFns } from "./Dispatch.vue?vue&type=template&id=09805c3e&scoped=true"
import script from "./Dispatch.vue?vue&type=script&lang=js"
export * from "./Dispatch.vue?vue&type=script&lang=js"
import style0 from "./Dispatch.vue?vue&type=style&index=0&id=09805c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09805c3e",
  null
  
)

export default component.exports